import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { motion } from "motion/react";
import CartItems from "./CartItems";
import { addAddress, addOrder, clearCart } from "../../stores/cart";
import PlaceOrdersService from "../../services/PlaceOrderService";
import Login from "../users/Login";
import Loader from "../../ui/Loader";

function CheckOut() {
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();

  const auth = useSelector((store) => store.user);
  const usertoken = auth.token;
  const username = auth.name;

  const initialAddress = {
    address: "",
    city: "",
    postcode: username ? username : "empty",
    country: "",
    telephone: "",
  };

  const dispatch = useDispatch();
  const [serverMessage, setServerMessage] = useState("");
  const [submitted, setSubmited] = useState(false);
  const cartitems = useSelector((store) => store.cart.items);

  const stateAddress = useSelector((store) => store.cart.addresses);

  const [orderTotal, setOrderTotal] = useState(0);

  const initialOrder = {
    id: null,
    paymentmethod: "Cash",
    totalprice: orderTotal,
    ispaid: "0",
    paidat: "0",
    isdelivered: "0",
    deliveredat: "0",
  };
  const [paddress, setPaddress] = useState(
    stateAddress.leght > 0 ? stateAddress : initialAddress
  );
  const [porder, SetPorder] = useState(initialOrder);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPaddress({ ...paddress, [name]: value });
  };

  const saveOrder = () => {
    var data = {
      id: porder.id,
      paymentmethod: porder.paymentmethod,
      totalprice: orderTotal,
      ispaid: porder.ispaid,
      paidat: porder.paidat,
      isdelivered: porder.isdelivered,
      deliveredat: porder.deliveredat,
      addresses: [paddress],
      orderitems: cartitems,
      published: false,
    };

    // console.log(data);

    PlaceOrdersService.create(data)
      .then((response) => {
        SetPorder({
          id: response.data.id,
          paymentmethod: response.data.paymentmethod,
          totalprice: response.data.totalprice,
          ispaid: response.data.ispaid,
          paidat: response.data.paidat,
          isdelivered: response.data.isdelivered,
          deliveredat: response.data.deliveredat,
          published: response.data.published,
        });

        // console.log("Order Created:", JSON.stringify(porder));

        dispatch(
          addOrder({
            id: response.data.id,
            paymentmethod: response.data.paymentmethod,
            totalprice: response.data.totalprice,
            ispaid: response.data.ispaid,
            paidat: response.data.paidat,
            isdelivered: response.data.isdelivered,
            deliveredat: response.data.deliveredat,
            published: response.data.published,
          })
        );
        navigate(`/checkout/order/${response.data.id}`);

        setSubmited(true);
        setServerMessage(response.data.serverMessage);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // const newOrder = () => {
  //   SetPorder(initialOrder);
  //   setSubmited(false);
  // };

  const placeOrder = () => {
    console.log("Place Order Clicked");
    setIsLoading(true);
    dispatch(addAddress(paddress));
    saveOrder();
    dispatch(clearCart());
  };

  useEffect(() => {
    let total = 0;
    total = cartitems
      .reduce((acc, item) => acc + item.quantity * item.price, 0)
      .toFixed(2);

    setOrderTotal(total);
  }, [cartitems, porder]);

  useEffect(() => {
    if (!usertoken) {
      navigate("/login");
    }
  }, [navigate, usertoken]);

  console.log("Initial Token:", usertoken);
  console.log("Paddress:", paddress);
  return (
    <div className="">
      {isLoading ? <Loader /> : ""}
      <>
        {!isLoading && orderTotal <= 1 ? (
          <div className=" container flex w-full content-center">
            Your Cart is Empty!! Please add some items.
          </div>
        ) : (
          <div className="sm:flex flex-row-2">
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              viewport={{ once: true }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.5,
                  x: { type: "spring", stiffness: 60 },
                  opacity: { duration: 0.6 },
                  ease: "easeIn",
                },
              }}
              className="sm:w-1/2 justify-center
    items-center
    overflow-hidden"
            >
              {usertoken ? (
                <>
                  <h1 className="text-4xl px-4 lg:text-3xl font-semibold pt-10">
                    Shipping Details
                  </h1>
                  <div>
                    {submitted ? (
                      <div
                        className="bg-green-100 border border-green-700 text-clay-500 px-4 py-3 rounded relative"
                        role="alert"
                      >
                        <p style={{ marginBottom: "0" }}>{serverMessage}</p>
                      </div>
                    ) : (
                      <>
                        <p style={{ marginBottom: "0" }}>{serverMessage}</p>
                      </>
                    )}
                    <br></br>
                  </div>

                  <form className="w-full">
                    <div className="md:flex md:items-center mb-6">
                      <div className="md:w-1/3">
                        <label
                          className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                          htmlFor="inline-full-name"
                        >
                          Name
                        </label>
                      </div>
                      <div className="md:w-2/3">
                        <input
                          className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                          id="postcode"
                          name="postcode"
                          type="text"
                          value={username}
                          required
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="md:flex md:items-center mb-6">
                      <div className="md:w-1/3">
                        <label
                          className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                          htmlFor="inline-full-name"
                        >
                          Phone
                        </label>
                      </div>
                      <div className="md:w-2/3">
                        <input
                          className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                          id="telephone"
                          name="telephone"
                          type="text"
                          value={paddress.telephone}
                          required
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="md:flex md:items-center mb-6">
                      <div className="md:w-1/3">
                        <label
                          className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                          htmlFor="inline-full-name"
                        >
                          City
                        </label>
                      </div>
                      <div className="md:w-2/3">
                        <input
                          className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                          id="city"
                          name="city"
                          type="text"
                          value={paddress.city}
                          required
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="md:flex md:items-center mb-6">
                      <div className="md:w-1/3">
                        <label
                          className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                          htmlFor="inline-full-name"
                        >
                          Address
                        </label>
                      </div>
                      <div className="md:w-2/3">
                        <textarea
                          rows="4"
                          className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                          id="address"
                          name="address"
                          type="text"
                          value={paddress.address}
                          required
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </form>

                  <div className="md:flex md:items-center">
                    <div className="md:w-2/3 grid grid-cols-2 pb-6">
                      <span></span>
                      <button
                        className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                        type="submit"
                        onClick={placeOrder}
                      >
                        Place Order
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <Login />
              )}
            </motion.div>

            <div className={"sm:w-1/2 p-9"}>
              <motion.div
                initial={{ x: 100, opacity: 0 }}
                viewport={{ once: true }}
                whileInView={{
                  x: 0,
                  opacity: 1,
                  transition: {
                    delay: 0.5,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 0.6 },
                    ease: "easeIn",
                  },
                }}
                className="font-serif italic pb-5"
              >
                <div></div>
              </motion.div>

              <motion.div
                initial={{ x: 100, opacity: 0 }}
                viewport={{ once: true }}
                whileInView={{
                  x: 0,
                  opacity: 1,
                  transition: {
                    delay: 0.5,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 0.6 },
                    ease: "easeIn",
                  },
                }}
                className="relative flex flex-col my-6 bg-gray-500 shadow-sm border border-slate-200 rounded-lg w-full"
              >
                <div className="p-4">
                  <div className="">
                    <div className="p-5">
                      {cartitems.map((item, key) => (
                        <CartItems
                          data={item}
                          key={key}
                        />
                      ))}
                    </div>
                    <h1 className="pl-8 text-3xl text-white">
                      Order Total {orderTotal}
                    </h1>
                  </div>
                </div>
              </motion.div>
              <div></div>
            </div>
          </div>
        )}
      </>
    </div>
  );
}

export default CheckOut;
